// extracted by mini-css-extract-plugin
module.exports = {"info":"_8020407"};